/* eslint sort-imports: "error" */
/* eslint sort-keys: "error" */
import { accceptOrDeclineBookingModificationRequest } from './accceptOrDeclineBookingModificationRequest';
import { acceptTenant } from './acceptTenant';
import { activateUser } from './activateUser';
import { addFavoriteListing } from './addFavoriteListing';
import { addFavoriteUnitType } from './inventory/addFavoriteUnitType';
import { addListingExclusions } from './addListingExclusions';
import { addPayoutMethod } from './addPayoutMethod';
import { addPoiDraft } from './addPoiDraft';
import { addQualificationRequirements } from './qualifications/addQualificationRequirements';
import { addQualificationRequirementsDefaults } from './qualifications/addQualificationRequirementsDefaults';
import { addReviewReportObjection } from './addReviewReportObjection';
import { addReviewSurveyReport } from './addReviewSurveyReport';
import { addSavedSearch } from './addSavedSearch';
import { addTenantReviewReply } from './surveyReviews/addTenantReviewReply';
import { addYoutubeVideo } from './addYoutubeVideo';
import { addYoutubeVideoUnitType } from './inventory/addYoutubeVideoUnitType';
import { cancelBooking } from './cancelBooking';
import { cancelConversation } from './cancelConversation';
import { cancelSubscription } from './cancelSubscription';
import { changeConversationDate } from './changeConversationDate';
import { changeListingVideoOrder } from './changeListingVideoOrder';
import { chargeTenant } from './chargeTenant';
import { confirmListingPhotoUpload } from './confirmListingPhotoUpload';
import { confirmListingVideoUpload } from './confirmListingVideoUpload';
import { confirmPayIn } from './payments/confirmPayIn';
import { confirmPaymentMethod } from './payments/confirmPaymentMethod';
import { confirmPayoutMethod } from './confirmPayoutMethod';
import { confirmUnitTypePhotoUpload } from './inventory/confirmUnitTypePhotoUpload';
import { confirmUnitTypeVideoUpload } from './inventory/confirmUnitTypeVideoUpload';
import { confirmUser } from './confirmUser';
import { confirmUserDocumentUpload } from './confirmUserDocumentUpload';
import { createBookingModificationRequest } from './createBookingModificationByTenant';
import { createBookingRequest } from './createBookingRequest';
import { createConversation } from './createConversation';
import { createListing } from './createListing';
import { createMakeCall } from './createMakeCall';
import { createPayIn } from './payments/createPayIn';
import { createPaymentIntent } from './createPaymentIntent';
import { createPaymentMethod } from './payments/createPaymentMethod';
import { createProperty } from './inventory/createPropety';
import { createProspectiveLead } from './createProspectiveLead';
import { createQuickReply } from './createQuickReply';
import { createSettlement } from './payments/createSettlement';
import { createSubscription } from './createSubscription';
import { createUnitType } from './inventory/createUnitType';
import { declineConversation } from './declineConversation';
import { deleteConversationAttachment } from './deleteConversationAttachment';
import { deleteKycDocument } from './deleteKycDocument';
import { deleteListing } from './deleteListing';
import { deleteListingExclusions } from './deleteListingExclusions';
import { deleteListingPhoto } from './deleteListingPhoto';
import { deleteListingVideo } from './deleteListingVideo';
import { deleteListingVideos } from './deleteListingVideos';
import { deletePaymentMethod } from './deletePaymentMethod';
import { deleteQualificationRequirement } from './qualifications/deleteQualificationRequirement';
import { deleteQualificationRequirementsDefaults } from './qualifications/deleteQualificationRequirementsDefaults';
import { deleteQuickReply } from './deleteQuickReply';
import { deleteUnitType } from './inventory/deleteUnitType';
import { deleteUnitTypePhoto } from './inventory/deleteUnitTypePhoto';
import { deleteUnitTypeVideo } from './inventory/deleteUnitTypeVideo';
import { deleteUser } from './deleteUser';
import { deleteUserDocument } from './deleteUserDocument';
import { duplicateListing } from './duplicateListing';
import { duplicateUnitType } from './inventory/duplicateUnitType';
import { editTenantReviewReply } from './surveyReviews/editTenantReviewReply';
import { editUserDocument } from './editUserDocument';
import { facebookLogin } from './facebookLogin';
import { finalizeBooking } from './finalizeBooking';
import { generateListingClick } from './generateListingClick';
import { getAllPayoutMethodRouting } from './payments/getAllPayoutMethodRouting';
import { getBillingInformation } from './payments/getBillingInformation';
import { getBookingModificationById } from './getBookingModificationById';
import { getCities } from './getCities';
import { getCitiesNearby } from './getCitiesNearby';
import { getCommissionPlan } from './payments/getCommissionPlan';
import { getCommissionPlans } from './getCommissionPlans';
import { getConversation } from './getConversation';
import { getConversationByToken } from './getConversationByToken';
import { getConversationCommissionInvoice } from './payments/getConversationCommissionInvoice';
import { getConversationCounters } from './getConversationCounters';
import { getConversationMessages } from './getConversationMessages';
import { getConversationPayoutInfo } from './getConversationPayoutInfo';
import { getConversations } from './getConversations';
import { getCurrencyEuroRates } from './getCurrencyEuroRates';
import { getEngagements } from './getEngagements';
import { getFavoriteListings } from './getFavoriteListings';
import { getFavoriteUnitTypes } from './inventory/getFavoriteUnitTypes';
import { getFeaturedCities } from './getFeaturedCities';
import { getFullUrl } from './getFullUrl';
import { getGlobalCounters } from './getGlobalCounters';
import { getInvoices } from './getInvoices';
import { getKycCountries } from './getKycCountries';
import { getKycDocuments } from './getKycDocuments';
import { getKycInfo } from './getKycInfo';
import { getLastMessageInConversation } from './getLastMessageInConversation';
import { getListingBookablePeriods } from './getListingBookablePeriods';
import { getListingById } from './getListingById';
import { getListingCosts } from './getListingCosts';
import { getListingExclusions } from './getListingExclusions';
import { getListingIcsCalendarLink } from './getListingIcsCalendarLink';
import { getListingPhotos } from './getListingPhotos';
import { getListingVideos } from './getListingVideos';
import { getListings } from './getListings';
import { getListingsConfiguration } from './getListingsConfiguration';
import { getListingsSummary } from './getListingsSummary';
import { getMultiBillingInformation } from './payments/getMultiBillingInformation';
import { getNotificationStatus } from './getNotificationStatus';
import { getNotifications } from './getNotifications';
import { getPayIn } from './payments/getPayIn';
import { getPayInTypes } from './payments/getPayInTypes';
import { getPayInsBySettlement } from './payments/getPayInsBySettlement';
import { getPaymentMethod } from './payments/getPaymentMethod';
import { getPaymentMethodTypes } from './payments/getPaymentMethodTypes';
import { getPaymentMethods } from './getPaymentMethods';
import { getPayoutMethod } from './getPayoutMethod';
import { getPayoutMethodRouting } from './payments/getPayoutMethodRouting';
import { getPayoutMethodRoutingPaymentReq } from './payments/getPayoutMethodRoutingPaymentReq';
import { getPayoutMethods } from './getPayoutMethods';
import { getPayoutTransactions } from './payments/getPayoutTransactions';
import { getPoiCommercial } from './getPoiCommercial';
import { getPois } from './getPois';
import { getProducts } from './getProducts';
import { getQualificationRequirements } from './qualifications/getQualificationRequirements';
import { getQualificationRequirementsByListing } from './qualifications/getQualificationRequirementsByListing';
import { getQualificationRequirementsByUnitType } from './qualifications/getQualificationRequirementsByUnitType';
import { getQualificationRequirementsDefaults } from './qualifications/getQualificationRequirementsDefaults';
import { getQuickReplies } from './getQuickReplies';
import { getRealtimeToken } from './getRealtimeToken';
import { getRentalConditionsByConversationId } from './getRentalConditionsByConversationId';
import { getRentalConditionsById } from './getRentalConditionsById';
import { getRentalConditionsEstimate } from './getRentalConditionsEstimate';
import { getReviewAdvertiserOverallRating } from './surveyReviews/getReviewAdvertiserOverallRating';
import { getReviewAdvertiserReports } from './surveyReviews/getReviewAdvertiserReports';
import { getReviewReport } from './surveyReviews/getReviewReport';
import { getReviewSurvey } from './getReviewSurvey';
import { getReviewSurveys } from './getReviewSurveys';
import { getSavedSearches } from './getSavedSearches';
import { getSettlement } from './payments/getSettlement';
import { getSharedDocuments } from './getSharedDocuments';
import { getSimilarListings } from './getSimilarListings';
import { getSitemaps } from './getSitemaps';
import { getSubscriptionProductsByHandle } from './getSubscriptionProductsByHandle';
import { getSubscriptions } from './getSubscriptions';
import { getSupportedMultiPayoutCurrencies } from './getSupportedCurrencies';
import { getUnitTypeBookablePeriods } from './inventory/getUnitTypeBookablePeriods';
import { getUnitTypeById } from './inventory/getUnitTypeById';
import { getUnitTypePhotos } from './inventory/getUnitTypePhotos';
import { getUnitTypes } from './inventory/getUnitTypes';
import { getUnitTypesSummary } from './inventory/getUnitTypesSummary';
import { getUniversities } from './getUniversities';
import { getUser } from './getUser';
import { getUserDocumentViewUrl } from './getUserDocumentViewUrl';
import { getUserDocuments } from './getUserDocuments';
import { getUserInformation } from './getUserInformation';
import { getUserKycs as getUserKYCs } from './getUserKycs';
import { getUserKycByUuid } from './getUserKycByUuid';
import { getUserPaymentMethods } from './payments/getUserPaymentMethods';
import { getUserSubscriptions } from './getUserSubscriptions';
import { getUsers } from './getUsers';
import { googleLogin } from './googleLogin';
import { googleLogin as googleOneTapLogin } from './googleOneTapLogin';
import { impersonateUser } from './impersonateUser';
import { linkDocumentToConversation } from './linkDocumentToConversation';
import { linkKycDocument } from './linkKycDocument';
import { login } from './login';
import { logout } from './logout';
import { makeSpecialOffer } from './makeSpecialOffer';
import { markAllNotificationsAsRead } from './markAllNotificationsAsRead';
import { markConversationAsRead } from './markConversationAsRead';
import { markNotificationAsRead } from './markNotificationAsRead';
import { postUserDocumentRequest } from './postUserDocumentRequest';
import { postUserKyc as postUserKYC } from './postUserKyc';
import { publishListing } from './publishListing';
import { publishUnitType } from './inventory/publishUnitType';
import { putUserKyc as putUserKYC } from './putUserKyc';
import { qualificationQualifyUser } from './qualifications/qualificationQualifyUser';
import { reactivateSubscription } from './reactivateSubscription';
import { recoverAccount } from './recoverAccount';
import { register } from './register';
import { registerListingCall as registerListingClick } from './registerListingClick';
import { removeFavoriteListing } from './removeFavoriteListing';
import { removeFavoriteUnitType } from './inventory/removeFavoriteUnitType';
import { removePayoutMethod } from './removePayoutMethod';
import { removeSavedSearch } from './removeSavedSearch';
import { replacesListingExclusions } from './replacesListingExclusions';
import { reportUser } from './reportUser';
import { requestActivationEmail } from './requestActivationEmail';
import { requestCode } from './requestCode';
import { requestListingPhotoUpload } from './requestListingPhotoUpload';
import { requestListingVideoUpload } from './requestListingVideoUpload';
import { requestUnitTypePhotoUpload } from './inventory/requestUnitTypePhotoUpload';
import { requestUnitTypeVideoUpload } from './inventory/requestUnitTypeVideoUpload';
import { resetPassword } from './resetPassword';
import { saveSearch } from './saveSearch';
import { searchCity } from './searchCity';
import { sendMessage } from './sendMessage';
import { setPayoutMethodAsDefault } from './setPayoutMethodAsDefault';
import { surveyUnpublishListing } from './surveyUnpublishListing';
import { surveyUnpublishUnitType } from './inventory/surveyUnpublishUnitType';
import { toggleArchiveConversation } from './toggleArchiveConversation';
import { toggleFavoriteConversation } from './toggleFavoriteConversation';
import { translateListingDescription } from './translateListingDescription';
import { unpublishListing } from './unpublishListing';
import { unpublishUnitType } from './inventory/unpublishUnitType';
import { updateBillingInformation } from './payments/updateBillingInformation';
import { updateKycStatus } from './updateKycStatus';
import { updateListing } from './updateListing';
import { updateListingPhoto } from './updateListingPhoto';
import { updateListingPhotosOrder } from './updateListingPhotosOrder';
import { updatePayoutMethod } from './updatePayoutMethod';
import { updatePayoutMethodRouting } from './payments/updatePayoutMethodRouting';
import { updateQualificationRequirementsByListing } from './qualifications/updateQualificationRequirementsByListing';
import { updateQualificationRequirementsByUnitType } from './qualifications/updateQualificationRequirementsByUnitType';
import { updateQualificationRequirementsDefaults } from './qualifications/updateQualificationRequirementsDefaults';
import { updateQuickReply } from './updateQuickReply';
import { updateUnitType } from './inventory/updateUnitType';
import { updateUnitTypePhoto } from './inventory/updateUnitTypePhoto';
import { updateUnitTypePhotosOrder } from './inventory/updateUnitTypePhotosOrder';
import { updateUser } from './updateUser';
import { updateUserSubscriptions } from './updateUserSubscriptions';
import { uploadAvatar } from './uploadAvatar';
import { uploadAvatarByUrl } from './uploadAvatarByUrl';
import { validateBillingInformation } from './payments/validateBillingInformation';
import { validatePhone } from './validatePhone';
import { verifyCode } from './verifyCode';
import { verifyManually } from './verifyManually';

interface FetchClient {
  fetch: (url: string, options: RequestInit) => Promise<Response>;
}

export const apiV2 = (fetchClient: FetchClient) => {
  const makeCall = createMakeCall(fetchClient);

  return {
    accceptOrDeclineBookingModificationRequest:
      accceptOrDeclineBookingModificationRequest(makeCall),
    acceptTenant: acceptTenant(makeCall),
    activateUser: activateUser(makeCall),
    addFavoriteListing: addFavoriteListing(makeCall),
    addFavoriteUnitType: addFavoriteUnitType(makeCall),
    addListingExclusions: addListingExclusions(makeCall),
    addPayoutMethod: addPayoutMethod(makeCall),
    addPoiDraft: addPoiDraft(makeCall),
    addQualificationRequirements: addQualificationRequirements(makeCall),
    addQualificationRequirementsDefaults:
      addQualificationRequirementsDefaults(makeCall),
    addReviewReportObjection: addReviewReportObjection(makeCall),
    addReviewSurveyReport: addReviewSurveyReport(makeCall),
    addSavedSearch: addSavedSearch(makeCall),
    addTenantReviewReply: addTenantReviewReply(makeCall),
    addYoutubeVideo: addYoutubeVideo(makeCall),
    addYoutubeVideoUnitType: addYoutubeVideoUnitType(makeCall),
    cancelBooking: cancelBooking(makeCall),
    cancelConversation: cancelConversation(makeCall),
    cancelSubscription: cancelSubscription(makeCall),
    changeConversationDate: changeConversationDate(makeCall),
    changeListingVideoOrder: changeListingVideoOrder(makeCall),
    chargeTenant: chargeTenant(makeCall),
    confirmListingPhotoUpload: confirmListingPhotoUpload(makeCall),
    confirmListingVideoUpload: confirmListingVideoUpload(makeCall),
    confirmPayIn: confirmPayIn(makeCall),
    confirmPaymentMethod: confirmPaymentMethod(makeCall),
    confirmPayoutMethod: confirmPayoutMethod(makeCall),
    confirmUnitTypePhotoUpload: confirmUnitTypePhotoUpload(makeCall),
    confirmUnitTypeVideoUpload: confirmUnitTypeVideoUpload(makeCall),
    confirmUser: confirmUser(makeCall),
    confirmUserDocumentUpload: confirmUserDocumentUpload(makeCall),
    createBookingModificationRequest:
      createBookingModificationRequest(makeCall),
    createBookingRequest: createBookingRequest(makeCall),
    createConversation: createConversation(makeCall),
    createListing: createListing(makeCall),
    createPayIn: createPayIn(makeCall),
    createPaymentIntent: createPaymentIntent(makeCall),
    createPaymentMethod: createPaymentMethod(makeCall),
    createProperty: createProperty(makeCall),
    createProspectiveLead: createProspectiveLead(makeCall),
    createQuickReply: createQuickReply(makeCall),
    createSettlement: createSettlement(makeCall),
    createSubscription: createSubscription(makeCall),
    createUnitType: createUnitType(makeCall),
    declineConversation: declineConversation(makeCall),
    deleteConversationAttachment: deleteConversationAttachment(makeCall),
    deleteKycDocument: deleteKycDocument(makeCall),
    deleteListing: deleteListing(makeCall),
    deleteListingExclusions: deleteListingExclusions(makeCall),
    deleteListingPhoto: deleteListingPhoto(makeCall),
    deleteListingVideo: deleteListingVideo(makeCall),
    deleteListingVideos: deleteListingVideos(makeCall),
    deletePaymentMethod: deletePaymentMethod(makeCall),
    deleteQualificationRequirement: deleteQualificationRequirement(makeCall),
    deleteQualificationRequirementsDefaults:
      deleteQualificationRequirementsDefaults(makeCall),
    deleteQuickReply: deleteQuickReply(makeCall),
    deleteUnitType: deleteUnitType(makeCall),
    deleteUnitTypePhoto: deleteUnitTypePhoto(makeCall),
    deleteUnitTypeVideo: deleteUnitTypeVideo(makeCall),
    deleteUser: deleteUser(makeCall),
    deleteUserDocument: deleteUserDocument(makeCall),
    duplicateListing: duplicateListing(makeCall),
    duplicateUnitType: duplicateUnitType(makeCall),
    editTenantReviewReply: editTenantReviewReply(makeCall),
    editUserDocument: editUserDocument(makeCall),
    facebookLogin: facebookLogin(makeCall),
    finalizeBooking: finalizeBooking(makeCall),
    generateListingClick: generateListingClick(makeCall),
    getAllPayoutMethodRouting: getAllPayoutMethodRouting(makeCall),
    getBillingInformation: getBillingInformation(makeCall),
    getBookingModificationById: getBookingModificationById(makeCall),
    getCities: getCities(makeCall),
    getCitiesNearby: getCitiesNearby(makeCall),
    getCommissionPlan: getCommissionPlan(makeCall),
    getCommissionPlans: getCommissionPlans(makeCall),
    getConversation: getConversation(makeCall),
    getConversationByToken: getConversationByToken(makeCall),
    getConversationCommissionInvoice:
      getConversationCommissionInvoice(makeCall),
    getConversationCounters: getConversationCounters(makeCall),
    getConversationMessages: getConversationMessages(makeCall),
    getConversationPayoutInfo: getConversationPayoutInfo(makeCall),
    getConversations: getConversations(makeCall),
    getCurrencyEuroRates: getCurrencyEuroRates(makeCall),
    getEngagements: getEngagements(makeCall),
    getFavoriteListings: getFavoriteListings(makeCall),
    getFavoriteUnitTypes: getFavoriteUnitTypes(makeCall),
    getFeaturedCities: getFeaturedCities(makeCall),
    getFullUrl: getFullUrl(makeCall),
    getGlobalCounters: getGlobalCounters(makeCall),
    getInvoices: getInvoices(makeCall),
    getKycCountries: getKycCountries(makeCall),
    getKycDocuments: getKycDocuments(makeCall),
    getKycInfo: getKycInfo(makeCall),
    getLastMessageInConversation: getLastMessageInConversation(makeCall),
    getListingBookablePeriods: getListingBookablePeriods(makeCall),
    getListingById: getListingById(makeCall),
    getListingCosts: getListingCosts(makeCall),
    getListingExclusions: getListingExclusions(makeCall),
    getListingIcsCalendarLink: getListingIcsCalendarLink(makeCall),
    getListingPhotos: getListingPhotos(makeCall),
    getListingVideos: getListingVideos(makeCall),
    getListings: getListings(makeCall),
    getListingsConfiguration: getListingsConfiguration(makeCall),
    getListingsSummary: getListingsSummary(makeCall),
    getMultiBillingInformation: getMultiBillingInformation(makeCall),
    getNotificationStatus: getNotificationStatus(makeCall),
    getNotifications: getNotifications(makeCall),
    getPayIn: getPayIn(makeCall),
    getPayInTypes: getPayInTypes(makeCall),
    getPayInsBySettlement: getPayInsBySettlement(makeCall),
    getPaymentMethod: getPaymentMethod(makeCall),
    getPaymentMethodTypes: getPaymentMethodTypes(makeCall),
    getPaymentMethods: getPaymentMethods(makeCall),
    getPayoutMethod: getPayoutMethod(makeCall),
    getPayoutMethodRouting: getPayoutMethodRouting(makeCall),
    getPayoutMethodRoutingPaymentReq:
      getPayoutMethodRoutingPaymentReq(makeCall),
    getPayoutMethods: getPayoutMethods(makeCall),
    getPayoutTransactions: getPayoutTransactions(makeCall),
    getPoiCommercial: getPoiCommercial(makeCall),
    getPois: getPois(makeCall),
    getProducts: getProducts(makeCall),
    getQualificationRequirements: getQualificationRequirements(makeCall),
    getQualificationRequirementsByListing:
      getQualificationRequirementsByListing(makeCall),
    getQualificationRequirementsByUnitType:
      getQualificationRequirementsByUnitType(makeCall),
    getQualificationRequirementsDefaults:
      getQualificationRequirementsDefaults(makeCall),
    getQuickReplies: getQuickReplies(makeCall),
    getRealtimeToken: getRealtimeToken(makeCall),
    getRentalConditionsByConversationId:
      getRentalConditionsByConversationId(makeCall),
    getRentalConditionsById: getRentalConditionsById(makeCall),
    getRentalConditionsEstimate: getRentalConditionsEstimate(makeCall),
    getReviewAdvertiserOverallRating:
      getReviewAdvertiserOverallRating(makeCall),
    getReviewAdvertiserReports: getReviewAdvertiserReports(makeCall),
    getReviewReport: getReviewReport(makeCall),
    getReviewSurvey: getReviewSurvey(makeCall),
    getReviewSurveys: getReviewSurveys(makeCall),
    getSavedSearches: getSavedSearches(makeCall),
    getSettlement: getSettlement(makeCall),
    getSharedDocuments: getSharedDocuments(makeCall),
    getSimilarListings: getSimilarListings(makeCall),
    getSitemaps: getSitemaps(makeCall),
    getSubscriptionProductsByHandle: getSubscriptionProductsByHandle(makeCall),
    getSubscriptions: getSubscriptions(makeCall),
    getSupportedMultiPayoutCurrencies:
      getSupportedMultiPayoutCurrencies(makeCall),
    getUnitTypeBookablePeriods: getUnitTypeBookablePeriods(makeCall),
    getUnitTypeById: getUnitTypeById(makeCall),
    getUnitTypePhotos: getUnitTypePhotos(makeCall),
    getUnitTypes: getUnitTypes(makeCall),
    getUnitTypesSummary: getUnitTypesSummary(makeCall),
    getUniversities: getUniversities(makeCall),
    getUser: getUser(makeCall),
    getUserDocumentViewUrl: getUserDocumentViewUrl(makeCall),
    getUserDocuments: getUserDocuments(makeCall),
    getUserInformation: getUserInformation(makeCall),
    getUserKYCs: getUserKYCs(makeCall),
    getUserKycByUuid: getUserKycByUuid(makeCall),
    getUserPaymentMethods: getUserPaymentMethods(makeCall),
    getUserSubscriptions: getUserSubscriptions(makeCall),
    getUsers: getUsers(makeCall),
    googleLogin: googleLogin(makeCall),
    googleOneTapLogin: googleOneTapLogin(makeCall),
    impersonateUser: impersonateUser(makeCall),
    linkDocumentToConversation: linkDocumentToConversation(makeCall),
    linkKycDocument: linkKycDocument(makeCall),
    login: login(makeCall),
    logout: logout(makeCall),
    makeSpecialOffer: makeSpecialOffer(makeCall),
    markAllNotificationsAsRead: markAllNotificationsAsRead(makeCall),
    markConversationAsRead: markConversationAsRead(makeCall),
    markNotificationAsRead: markNotificationAsRead(makeCall),
    postUserDocumentRequest: postUserDocumentRequest(makeCall),
    postUserKYC: postUserKYC(makeCall),
    publishListing: publishListing(makeCall),
    publishUnitType: publishUnitType(makeCall),
    putUserKYC: putUserKYC(makeCall),
    qualificationQualifyUser: qualificationQualifyUser(makeCall),
    reactivateSubscription: reactivateSubscription(makeCall),
    recoverAccount: recoverAccount(makeCall),
    register: register(makeCall),
    registerListingClick: registerListingClick(makeCall),
    removeFavoriteListing: removeFavoriteListing(makeCall),
    removeFavoriteUnitType: removeFavoriteUnitType(makeCall),
    removePayoutMethod: removePayoutMethod(makeCall),
    removeSavedSearch: removeSavedSearch(makeCall),
    replacesListingExclusions: replacesListingExclusions(makeCall),
    reportUser: reportUser(makeCall),
    requestActivationEmail: requestActivationEmail(makeCall),
    requestCode: requestCode(makeCall),
    requestListingPhotoUpload: requestListingPhotoUpload(makeCall),
    requestListingVideoUpload: requestListingVideoUpload(makeCall),
    requestUnitTypePhotoUpload: requestUnitTypePhotoUpload(makeCall),
    requestUnitTypeVideoUpload: requestUnitTypeVideoUpload(makeCall),
    resetPassword: resetPassword(makeCall),
    saveSearch: saveSearch(makeCall),
    searchCity: searchCity(makeCall),
    sendMessage: sendMessage(makeCall),
    setPayoutMethodAsDefault: setPayoutMethodAsDefault(makeCall),
    surveyUnpublishListing: surveyUnpublishListing(makeCall),
    surveyUnpublishUnitType: surveyUnpublishUnitType(makeCall),
    toggleArchiveConversation: toggleArchiveConversation(makeCall),
    toggleFavoriteConversation: toggleFavoriteConversation(makeCall),
    translateListingDescription: translateListingDescription(makeCall),
    unpublishListing: unpublishListing(makeCall),
    unpublishUnitType: unpublishUnitType(makeCall),
    updateBillingInformation: updateBillingInformation(makeCall),
    updateKycStatus: updateKycStatus(makeCall),
    updateListing: updateListing(makeCall),
    updateListingPhoto: updateListingPhoto(makeCall),
    updateListingPhotosOrder: updateListingPhotosOrder(makeCall),
    updatePayoutMethod: updatePayoutMethod(makeCall),
    updatePayoutMethodRouting: updatePayoutMethodRouting(makeCall),
    updateQualificationRequirementsByListing:
      updateQualificationRequirementsByListing(makeCall),
    updateQualificationRequirementsByUnitType:
      updateQualificationRequirementsByUnitType(makeCall),
    updateQualificationRequirementsDefaults:
      updateQualificationRequirementsDefaults(makeCall),
    updateQuickReply: updateQuickReply(makeCall),
    updateUnitType: updateUnitType(makeCall),
    updateUnitTypePhoto: updateUnitTypePhoto(makeCall),
    updateUnitTypePhotosOrder: updateUnitTypePhotosOrder(makeCall),
    updateUser: updateUser(makeCall),
    updateUserSubscriptions: updateUserSubscriptions(makeCall),
    uploadAvatar: uploadAvatar(makeCall),
    uploadAvatarByUrl: uploadAvatarByUrl(makeCall),
    validateBillingInformation: validateBillingInformation(makeCall),
    validatePhone: validatePhone(makeCall),
    verifyCode: verifyCode(makeCall),
    verifyManually: verifyManually(makeCall),
  };
};
